import axios, { AxiosRequestConfig, AxiosInstance } from 'axios';
import { getToken } from '../helpers/Token';
import stickerMakerUrls from "../configs/sticker_maker/stickerMakerUrls";

interface ApiInterface extends AxiosInstance {
  oneSky?: any;
}

const onRequest = (config: AxiosRequestConfig): AxiosRequestConfig => {
  config.headers ||= {};
  config.headers['Content-Type'] = 'application/json';
  config.headers['Authorization'] = `Bearer ${getToken()}`;

  return config;
}

const mineCraftApi: ApiInterface = axios.create({ baseURL: stickerMakerUrls.baseURL })
mineCraftApi.interceptors.request.use(onRequest);

mineCraftApi.oneSky = {
  url: stickerMakerUrls.remoteUrl.bind(stickerMakerUrls),
  uploadHeaders: {
    'Authorization': `Bearer ${getToken()}`
  }
}

export default mineCraftApi;
